import { FallBackModule } from 'src/components/common/modules/fallback-module';
import v3SharedModules from 'src/components/common/modules/v3/shared';
import v3MesoModules from 'src/components/common/modules/v3/meso';
import v3BrandModules from 'src/components/common/modules/v3/brand';

type ModulesType = {
  [key: string]: () => any;
};

const v3Modules: ModulesType = {
  ...v3SharedModules,
  ...v3MesoModules,
  ...v3BrandModules,  
  default: () => FallBackModule,
};

export default v3Modules;
